import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import Shell from "../Shell";
import { authHeaders } from "../api";

export default function GroupNew() {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim()) {
      setError("Vinsamlegast settu inn nafn á hóp.");
      return;
    }
    setSaving(true);
    try {
      await api.post(
        "/api/groups/",
        { name: name.trim(), description: description.trim() || null },
        { headers: authHeaders() }
      );
      alert("Hópurinn var skráður.");
      nav("/groups"); // fer á yfirlit yfir hópa (má halda sem placeholder)
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.name?.join?.(" ") ||
        "Tókst ekki að skrá hóp.";
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Shell title="Hugarafl starfsfólk" rightMenu>
      <h2 style={{ textAlign: "center", margin: "8px 0 18px" }}>Skrá nýjan hóp</h2>

      <form onSubmit={submit} style={{ display: "grid", placeItems: "center" }}>
        <div
          className="card"
          style={{ width: "min(720px, 92vw)", borderRadius: 20, padding: 24 }}
        >
          <div className="field" style={{ marginBottom: 14 }}>
            <span>Nafn á hóp:</span>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="t.d. Hópur A"
            />
          </div>

          <div className="field" style={{ marginBottom: 18 }}>
            <span>Lýsing:</span>
            <textarea
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Stutt lýsing á hópnum (valkvætt)"
            />
          </div>

          {error ? (
            <div className="error" style={{ marginBottom: 10 }}>{error}</div>
          ) : null}

          <div style={{ textAlign: "center" }}>
            <button className="btn" disabled={saving}>
              {saving ? "Vista…" : "Samþykkja"}
            </button>
          </div>
        </div>
      </form>
    </Shell>
  );
}